var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStoreIconsGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "41px",
    viewBox: "0 0 136 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "app_store_icons_google") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.5016246%",
    y1: "4.96390252%",
    x2: "-38.3328176%",
    y2: "71.9033944%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "0.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51.22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76.04%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.584239%",
    y1: "50%",
    x2: "-130.468788%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "40.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: "77.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.2467789%",
    y1: "17.8460774%",
    x2: "-50.1372326%",
    y2: "194.808468%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.8097807%",
    y1: "-54.1572645%",
    x2: "42.0951696%",
    y2: "24.8657419%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "6.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "47.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "app_store_icons",
    transform: "translate(-244.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "app_store_icons_google",
    transform: "translate(244.937819, 30.316406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,40 L5,40 C2.25,40 0,37.75 0,35 L0,5 C0,2.25 2.25,0 5,0 L130,0 C132.75,0 135,2.25 135,5 L135,35 C135,37.75 132.75,40 130,40 L130,40 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,0.8 C132.316,0.8 134.2,2.684 134.2,5 L134.2,35 C134.2,37.316 132.316,39.2 130,39.2 L5,39.2 C2.684,39.2 0.8,37.316 0.8,35 L0.8,5 C0.8,2.684 2.684,0.8 5,0.8 L130,0.8 L130,0.8 Z M130,0 L5,0 C2.25,0 0,2.25 0,5 L0,35 C0,37.75 2.25,40 5,40 L130,40 C132.75,40 135,37.75 135,35 L135,5 C135,2.25 132.75,0 130,0 L130,0 L130,0 Z",
    id: "Shape",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 6.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.418,4.243 C6.418,5.081 6.17,5.748 5.673,6.246 C5.109,6.838 4.373,7.134 3.469,7.134 C2.603,7.134 1.866,6.834 1.261,6.234 C0.655,5.633 0.352,4.889 0.352,4.001 C0.352,3.112 0.655,2.368 1.261,1.768 C1.866,1.167 2.603,0.867 3.469,0.867 C3.899,0.867 4.31,0.951 4.7,1.119 C5.091,1.287 5.404,1.51 5.638,1.789 L5.111,2.317 C4.714,1.842 4.167,1.605 3.468,1.605 C2.836,1.605 2.29,1.827 1.829,2.271 C1.368,2.715 1.138,3.292 1.138,4.001 C1.138,4.71 1.368,5.287 1.829,5.731 C2.29,6.175 2.836,6.397 3.468,6.397 C4.138,6.397 4.697,6.174 5.144,5.727 C5.434,5.436 5.602,5.031 5.647,4.512 L3.468,4.512 L3.468,3.791 L6.375,3.791 C6.405,3.947 6.418,4.098 6.418,4.243 L6.418,4.243 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.028 1.737 8.296 1.737 8.296 3.639 10.76 3.639 10.76 4.36 8.296 4.36 8.296 6.262 11.028 6.262 11.028 7 7.525 7 7.525 1 11.028 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.279,7 L13.508,7 L13.508,1.737 L11.832,1.737 L11.832,1 L15.955,1 L15.955,1.737 L14.279,1.737 L14.279,7 L14.279,7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "18.938 7 18.938 1 19.709 1 19.709 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.128,7 L22.357,7 L22.357,1.737 L20.681,1.737 L20.681,1 L24.804,1 L24.804,1.737 L23.128,1.737 L23.128,7 L23.128,7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.609,6.225 C32.019,6.832 31.286,7.134 30.409,7.134 C29.532,7.134 28.799,6.831 28.21,6.225 C27.62,5.619 27.326,4.877 27.326,4 C27.326,3.123 27.62,2.381 28.21,1.775 C28.799,1.168 29.532,0.865 30.409,0.865 C31.281,0.865 32.013,1.17 32.605,1.779 C33.197,2.388 33.493,3.128 33.493,4 C33.493,4.877 33.198,5.619 32.609,6.225 L32.609,6.225 Z M28.779,5.722 C29.223,6.172 29.766,6.396 30.409,6.396 C31.052,6.396 31.596,6.171 32.039,5.722 C32.483,5.272 32.706,4.698 32.706,4 C32.706,3.302 32.483,2.728 32.039,2.278 C31.596,1.828 31.052,1.604 30.409,1.604 C29.766,1.604 29.223,1.829 28.779,2.278 C28.336,2.728 28.113,3.302 28.113,4 C28.113,4.698 28.336,5.272 28.779,5.722 L28.779,5.722 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "34.575 7 34.575 1 35.513 1 38.429 5.667 38.462 5.667 38.429 4.511 38.429 1 39.2 1 39.2 7 38.395 7 35.344 2.106 35.311 2.106 35.344 3.262 35.344 7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.136,21.752 C65.784,21.752 63.867,23.54 63.867,26.005 C63.867,28.454 65.784,30.258 68.136,30.258 C70.488,30.258 72.405,28.454 72.405,26.005 C72.405,23.54 70.488,21.752 68.136,21.752 L68.136,21.752 Z M68.136,28.582 C66.847,28.582 65.735,27.519 65.735,26.004 C65.735,24.474 66.847,23.426 68.136,23.426 C69.425,23.426 70.536,24.473 70.536,26.004 C70.536,27.519 69.425,28.582 68.136,28.582 L68.136,28.582 Z M58.823,21.752 C56.471,21.752 54.554,23.54 54.554,26.005 C54.554,28.454 56.471,30.258 58.823,30.258 C61.175,30.258 63.092,28.454 63.092,26.005 C63.092,23.54 61.175,21.752 58.823,21.752 L58.823,21.752 Z M58.823,28.582 C57.534,28.582 56.422,27.519 56.422,26.004 C56.422,24.474 57.534,23.426 58.823,23.426 C60.112,23.426 61.223,24.473 61.223,26.004 C61.223,27.519 60.111,28.582 58.823,28.582 L58.823,28.582 Z M47.744,23.057 L47.744,24.861 L52.062,24.861 C51.933,25.876 51.595,26.617 51.079,27.133 C50.451,27.761 49.468,28.454 47.744,28.454 C45.086,28.454 43.008,26.311 43.008,23.653 C43.008,20.995 45.086,18.852 47.744,18.852 C49.178,18.852 50.225,19.416 50.998,20.141 L52.271,18.868 C51.192,17.837 49.758,17.048 47.744,17.048 C44.103,17.048 41.042,20.012 41.042,23.653 C41.042,27.294 44.103,30.258 47.744,30.258 C49.71,30.258 51.192,29.614 52.352,28.405 C53.544,27.213 53.915,25.537 53.915,24.184 C53.915,23.765 53.883,23.378 53.818,23.056 L47.744,23.057 L47.744,23.057 L47.744,23.057 Z M93.052,24.458 C92.698,23.507 91.618,21.752 89.411,21.752 C87.22,21.752 85.4,23.476 85.4,26.005 C85.4,28.389 87.204,30.258 89.621,30.258 C91.57,30.258 92.698,29.066 93.165,28.373 L91.715,27.406 C91.232,28.115 90.571,28.582 89.621,28.582 C88.67,28.582 87.994,28.147 87.559,27.293 L93.246,24.941 L93.052,24.458 L93.052,24.458 Z M87.252,25.876 C87.204,24.233 88.525,23.395 89.475,23.395 C90.216,23.395 90.844,23.765 91.054,24.297 L87.252,25.876 L87.252,25.876 Z M82.629,30 L84.498,30 L84.498,17.499 L82.629,17.499 L82.629,30 L82.629,30 Z M79.567,22.702 L79.503,22.702 C79.084,22.203 78.279,21.752 77.264,21.752 C75.137,21.752 73.188,23.621 73.188,26.021 C73.188,28.405 75.137,30.258 77.264,30.258 C78.279,30.258 79.084,29.807 79.503,29.291 L79.567,29.291 L79.567,29.903 C79.567,31.53 78.697,32.4 77.295,32.4 C76.151,32.4 75.442,31.578 75.152,30.886 L73.525,31.563 C73.992,32.691 75.233,34.076 77.295,34.076 C79.486,34.076 81.339,32.787 81.339,29.646 L81.339,22.01 L79.567,22.01 L79.567,22.702 L79.567,22.702 Z M77.425,28.582 C76.136,28.582 75.057,27.503 75.057,26.02 C75.057,24.522 76.136,23.426 77.425,23.426 C78.698,23.426 79.697,24.521 79.697,26.02 C79.696,27.503 78.698,28.582 77.425,28.582 L77.425,28.582 Z M101.806,17.499 L97.335,17.499 L97.335,30 L99.201,30 L99.201,25.264 L101.807,25.264 C103.875,25.264 105.908,23.767 105.908,21.382 C105.908,18.997 103.874,17.499 101.806,17.499 L101.806,17.499 Z M101.854,23.524 L99.2,23.524 L99.2,19.239 L101.854,19.239 C103.249,19.239 104.041,20.394 104.041,21.382 C104.041,22.35 103.249,23.524 101.854,23.524 L101.854,23.524 Z M113.386,21.729 C112.035,21.729 110.636,22.324 110.057,23.643 L111.714,24.335 C112.068,23.643 112.727,23.418 113.419,23.418 C114.384,23.418 115.365,23.997 115.381,25.026 L115.381,25.155 C115.043,24.962 114.319,24.672 113.435,24.672 C111.65,24.672 109.832,25.653 109.832,27.487 C109.832,29.16 111.296,30.237 112.936,30.237 C114.191,30.237 114.882,29.674 115.316,29.015 L115.38,29.015 L115.38,29.98 L117.181,29.98 L117.181,25.187 C117.181,22.967 115.525,21.729 113.386,21.729 L113.386,21.729 Z M113.161,28.58 C112.55,28.58 111.697,28.274 111.697,27.518 C111.697,26.553 112.759,26.183 113.675,26.183 C114.495,26.183 114.881,26.36 115.38,26.601 C115.235,27.76 114.238,28.58 113.161,28.58 L113.161,28.58 Z M123.743,22.002 L121.604,27.422 L121.54,27.422 L119.321,22.002 L117.311,22.002 L120.64,29.577 L118.742,33.791 L120.688,33.791 L125.819,22.002 L123.743,22.002 L123.743,22.002 Z M106.936,30 L108.802,30 L108.802,17.499 L106.936,17.499 L106.936,30 L106.936,30 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.435,0.538 C1.144,0.846 0.972,1.324 0.972,1.943 L0.972,24.059 C0.972,24.679 1.144,25.156 1.435,25.464 L1.509,25.536 L13.898,13.147 L13.898,13.001 L13.898,12.855 L1.509,0.465 L1.435,0.538 L1.435,0.538 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.028,17.278 L13.899,13.147 L13.899,13.001 L13.899,12.855 L18.029,8.725 L18.122,8.778 L23.015,11.558 C24.413,12.352 24.413,13.651 23.015,14.446 L18.122,17.226 L18.028,17.278 L18.028,17.278 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.122,17.225 L13.899,13.001 L1.435,25.464 C1.896,25.952 2.656,26.012 3.513,25.525 L18.122,17.225",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.122,8.777 L3.514,0.477 C2.657,-0.01 1.897,0.051 1.436,0.538 L13.899,13.001 L18.122,8.777 L18.122,8.777 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 17.000000)",
    id: "Shape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.029,0.132 L3.514,8.379 C2.702,8.84 1.976,8.81 1.51,8.39 L1.51,8.39 L1.436,8.465 L1.436,8.465 L1.51,8.537 L1.51,8.537 C1.976,8.957 2.702,8.988 3.514,8.526 L18.122,0.226 L18.029,0.132 L18.029,0.132 Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.435,8.318 C1.144,8.01 0.972,7.532 0.972,6.913 L0.972,7.059 C0.972,7.678 1.144,8.156 1.435,8.464 L1.509,8.389 L1.435,8.318 L1.435,8.318 Z",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.015,14.299 L18.029,17.132 L18.122,17.225 L23.015,14.445 C23.714,14.048 24.063,13.525 24.063,13.002 L24.063,13.002 C24.004,13.475 23.648,13.939 23.015,14.299 L23.015,14.299 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.514,0.623 L23.015,11.703 C23.649,12.063 24.004,12.527 24.063,13.001 L24.063,13.001 C24.063,12.478 23.714,11.954 23.015,11.557 L3.514,0.477 C2.116,-0.317 0.973,0.342 0.973,1.943 L0.973,2.089 C0.973,0.489 2.116,-0.171 3.514,0.623 L3.514,0.623 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.25
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreIconsGoogle);
export default __webpack_public_path__ + "static/media/app_store_icons_google.956850a84e009d440d0bd5a25ab33077.svg";
export { ForwardRef as ReactComponent };